import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=5de8fbfb&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=ts&"
export * from "./UploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=5de8fbfb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de8fbfb",
  null
  
)

export default component.exports